import profile from '../../fields/other/profile';
import rentalObject from '../../fields/shared/rentalObject';

export const MUTATION_UPDATE_PROFILE = /* GraphQL */ `
	mutation($input: ProfileUpdate!, $id: String!) {
		updateProfile(input: $input, id: $id) {
			${profile}
			rentalObjects {
				${rentalObject}
			}
		}
	}
`;
